import React, { useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import TableActions from "../../../components/Common/TableActions";
import {
  DELETE_PROMOCODE,
  DELETEREPORT,
  PROMOCODE_STATUS_CHANGE,
  REPORTLIST,
} from "../../../services/ApiCalls";
import dataHandler from "../../../hooks/dataHandler";
import moment from "moment";
import Toggle from "../../../components/Common/Toggle";
import Filter from "../../../components/Common/Filter";
import {
  activeInactiveOptions,
  defaultDeleteModelState,
} from "../../../utilities/const";

import u1 from "../../../Assets/images/authbg.png";
import { Link } from "react-router-dom";
// import { CstmPagination } from "../../../components/Common/Common";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import CustomPagination from "../../../components/Common/CustomPagination";

const Report = () => {
  const {
    setBody,
    statusChangeHandler,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    setCommisionModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: REPORTLIST,
  });

  const column = [
    {
      head: "Sr. No.",
      accessor: "#",
      component: (item, key) => {
        return <>{key < 9 ? `0${key + 1}` : key + 1}</>;
      },
    },
    {
      head: "Title Name",
      accessor: "title",
    },

    {
      head: "Description",
      accessor: "description",
      component: (item) => {
        const plainText = item.description
          ? item.description.replace(/<[^>]+>/g, "")
          : "";

        const words = plainText.split(/\s+/);
        const shortText =
          words.length > 15 ? words.slice(0, 15).join(" ") + "..." : plainText;

        return <p className="">{shortText}</p>;
      },
    },

    {
      head: "createdAt",
      accessor: "date_created",
      component: (item, key) => {
        return (
          <>
            <p>{moment(item.date_created).format("YYYY-MM-DD")}</p>
          </>
        );
      },
    },

    {
      head: "Status",
      accessor: "status",
      component: (item, key, arr) => (
        <span className="text-capitalize">{item?.status}</span>
      ),
    },

    {
      head: "Action",
      accessor: "Action",
      component: (item) => {
        console.log(item, "item");
        return (
          <TableActions
            editUrl={`/report/edit/${item._id}`}
            // viewLink={`/report/detail/${item._id}`}
            setDeleteModel={() =>
              setDeleteModel({ show: true, dumpId: item?._id })
            }
          />
        );
      },
    },
  ];

  const [confirmation, setConfirmation] = useState();
  const handleConfirmation = () => setConfirmation(!confirmation);
  
  return (
    <>
      <ConfirmationPop
        type={"delete"}
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel((p) => defaultDeleteModelState)}
        confirmHandler={() =>
          deleteHandler(() => DELETEREPORT({ _id: deleteModel.dumpId, status: "inactive" }))
        }
      />
      <section className="promocode py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                Manage Reports
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    setBody={setBody}
                    searchHandler={searchHandler}
                    statusFilterOptionArr={activeInactiveOptions}
                  />
                </div>
                <div className="right">
                  <Link
                    to="/report/add"
                    className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn "
                    style={{ height: 40, minWidth: 100, fontSize: 12 }}
                  >
                    Add New
                  </Link>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Report;
